import {CommonRootState} from '../types';

export const selectFeatureFlag = (state: CommonRootState, flag: string) =>
  state.featureFlags?.flags?.[flag] ?? false;

export const selectAqForecastEnabled = (state: CommonRootState) =>
  state.featureFlags?.flags?.['aq_forecast'] ?? false;

// Forecast maps viewer surface (backend flag `forecast_maps`). Fail-closed:
// a missing flag map (anon / not yet fetched) must hide the feature.
export const selectForecastMapsEnabled = (state: CommonRootState) =>
  state.featureFlags?.flags?.['forecast_maps'] ?? false;

// Forecast map composer/builder surface (backend flag `forecast_map_builder`).
// Defined ahead of the composer MR; same fail-closed rule.
export const selectForecastMapBuilderEnabled = (state: CommonRootState) =>
  state.featureFlags?.flags?.['forecast_map_builder'] ?? false;

// Interactive (MapLibre) forecast map view (backend flag
// `forecast_map_interactive`). Same fail-closed rule.
export const selectForecastMapInteractiveEnabled = (state: CommonRootState) =>
  state.featureFlags?.flags?.['forecast_map_interactive'] ?? false;

export const selectStripeConfig = (state: CommonRootState) =>
  state.featureFlags?.stripeConfig ?? null;
